import React from 'react';

/** Audio illustration — 22 vertical bars with varying heights, center section accented. */
// Heights are hand-picked to feel like a waveform rather than random.
const BARS = [
  { h: 22 }, { h: 38 }, { h: 55 }, { h: 72 }, { h: 48 },
  { h: 82 }, { h: 95 }, { h: 78 }, { h: 60 }, { h: 88, accent: true },
  { h: 100, accent: true }, { h: 92, accent: true }, { h: 76, accent: true },
  { h: 60 }, { h: 72 }, { h: 58 }, { h: 42 }, { h: 68 },
  { h: 48 }, { h: 34 }, { h: 26 }, { h: 18 },
];

const WaveformBars = () => (
  <div className="ill-waveform" aria-hidden="true">
    {BARS.map((b, i) => (
      <span
        key={i}
        className={b.accent ? 'accent' : undefined}
        style={{ '--h': `${b.h}%` }}
      />
    ))}
  </div>
);

export default WaveformBars;
